// DE drafted — queued for native review. Work orders (R-128): PM tasks raised
// by the site scheduler from the instantiated catalog + corrective work.
export const workOrders = {
  // R-244: work orders left the Maintenance tab bar and became their own screen,
  // so they need a page title of their own. `tabWorkOrders` is kept — the mobile
  // app and the SOC tile still label the link with it.
  pageTitle: { de: 'Arbeitsaufträge', en: 'Work orders' },
  tabWorkOrders: { de: 'Work Orders', en: 'Work orders' },
  pageDescLocalWo: {
    de: 'Arbeitsaufträge dieses Standorts — PM-Katalog-getaktet plus korrektive Aufträge; QR-Abschluss am Asset.',
    en: 'This site’s work orders — clocked by the PM catalog plus corrective jobs; QR completion at the asset.',
  },
  pageDescCloudWo: {
    de: 'Flottenweite Work-Order-Übersicht (nur Lesen) — Betrieb passiert an den Standorten.',
    en: 'Fleet-wide work-order view (read-only) — operation happens at the sites.',
  },

  statOpen: { de: 'Offene WOs', en: 'Open WOs' },
  statOverdue: { de: 'Überfällig', en: 'Overdue' },
  statDue7: { de: 'Fällig in 7 Tagen', en: 'Due in 7 days' },
  showAll: { de: 'Alle anzeigen', en: 'Show all' },
  showOpen: { de: 'Nur offene', en: 'Open only' },

  colNumber: { de: 'Nummer', en: 'Number' },
  colActivity: { de: 'Tätigkeit', en: 'Activity' },
  colKind: { de: 'Art', en: 'Kind' },
  colPmType: { de: 'PM-Typ', en: 'PM type' },
  colStatus: { de: 'Status', en: 'Status' },
  colDue: { de: 'Fällig', en: 'Due' },
  colSkill: { de: 'Skill', en: 'Skill' },
  colSite: { de: 'Standort', en: 'Site' },
  colUpdated: { de: 'Aktualisiert', en: 'Updated' },

  create: { de: 'Korrektiv-WO anlegen', en: 'New Corrective WO' },
  createSubmit: { de: 'Anlegen', en: 'Create' },
  cancel: { de: 'Abbrechen', en: 'Cancel' },
  fieldActivity: { de: 'Tätigkeit', en: 'Activity' },
  fieldActivityPh: { de: 'z. B. Pumpendichtung tauschen', en: 'e.g. Replace faulty pump seal' },
  fieldProcedure: { de: 'Vorgehen', en: 'Procedure' },
  fieldProcedurePh: {
    de: 'z. B. Schritte zur Diagnose und Behebung des Problems',
    en: 'e.g. Steps to diagnose and fix the problem',
  },
  fieldAsset: { de: 'Asset', en: 'Asset' },
  selectAsset: { de: '— Asset wählen —', en: '— select asset —' },
  fieldLocation: { de: 'Standort', en: 'Location' },
  selectLocation: { de: '— Standort wählen —', en: '— select location —' },
  fieldDue: { de: 'Fällig am', en: 'Due date' },

  start: { de: 'Starten', en: 'Start' },
  complete: { de: 'Abschließen', en: 'Complete' },
  cancelWo: { de: 'Stornieren', en: 'Cancel WO' },
  assignee: { de: 'Zugewiesen an', en: 'Assignee' },
  assignPh: { de: 'Zuweisen an…', en: 'Assign to…' },
  sectionDetails: { de: 'Details', en: 'Details' },
  sectionNotes: { de: 'Notizen', en: 'Notes' },
  sectionActions: { de: 'Aktionen', en: 'Actions' },
  completeNoteLabel: { de: 'Abschlussnotiz', en: 'Completion note' },
  toastCreated: { de: '{number} angelegt', en: '{number} created' },
  toastStarted: { de: '{number} gestartet', en: '{number} started' },
  toastCompleted: { de: '{number} abgeschlossen', en: '{number} completed' },
  toastCancelled: { de: '{number} storniert', en: '{number} cancelled' },
  toastAssigned: { de: 'Zugewiesen an {who}', en: 'Assigned to {who}' },
  readOnlyHint: {
    de: 'Nur-Lese-Zugriff — zum Anlegen oder Bearbeiten von Arbeitsaufträgen wird die Berechtigung „Wartung: Schreiben“ benötigt.',
    en: 'Read-only access — raising or managing work orders needs the Maintenance: Write permission.',
  },
  completeNotePh: { de: 'Abschlussnotiz…', en: 'Completion note…' },
  duration: { de: 'Dauer (min)', en: 'Duration (min)' },
  spares: { de: 'Ersatzteile/Werkzeug', en: 'Spares/tools' },
  completedVia: { de: 'Abgeschlossen via', en: 'Completed via' },

  emptyTitle: { de: 'Keine Work Orders', en: 'No work orders' },
  emptyMsg: {
    de: 'Der Scheduler erzeugt WOs aus fälligen PM-Aufgaben (stündlich).',
    en: 'The scheduler raises WOs from due PM tasks (hourly).',
  },
  loadError: { de: 'Work Orders konnten nicht geladen werden', en: 'Could not load work orders' },
  completeConfirmTitle: { de: '{number} abschließen?', en: 'Complete {number}?' },
  completeConfirmMsg: {
    de: 'Der Arbeitsauftrag wird als erledigt geschlossen. Bei PM-Aufträgen rückt die nächste Fälligkeit des Assets vor. Das lässt sich nicht rückgängig machen.',
    en: 'The work order closes as done. For PM orders the asset’s next due date advances. This cannot be undone.',
  },
  cancelConfirmTitle: { de: '{number} stornieren?', en: 'Cancel {number}?' },
  cancelConfirmMsg: {
    de: 'Der Arbeitsauftrag wird geschlossen, ohne ausgeführt zu werden. Bei PM-Aufträgen bleibt die Fälligkeit bestehen.',
    en: 'The work order closes without being carried out. For PM orders the due date remains.',
  },
} as const;
